import { Resource } from '@ekuaibao/fetch';
var payees = new Resource('/api/v1/form/payees');
export function getPayeeInfoByIds(ids) {
    return payees.GET('/[ids]', { ids: ids });
}
